<template>
    <ValidationObserver ref="observer" tag="div">
        <!-- ── Importe total ── -->
        <div class="tw:mb-8 tw:p-5 tw:bg-blue-50 tw:rounded-xl tw:border tw:border-blue-100 tw:flex tw:items-center tw:gap-4">
            <div class="tw:w-12 tw:h-12 tw:rounded-full tw:bg-blue-100 tw:flex tw:items-center tw:justify-center tw:text-blue-600 tw:flex-shrink-0">
                <svg class="tw:w-6 tw:h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"/>
                </svg>
            </div>
            <div>
                <p class="tw:text-sm tw:text-slate-600 tw:font-medium">Importe total de la categoría</p>
                <p class="tw:text-2xl tw:font-bold tw:text-slate-800">
                    {{ formatPrecio(importeTotal) }}
                </p>
            </div>
        </div>

        <!-- ── Descuento ── -->
        <div class="tw:flex tw:items-center tw:gap-2 tw:mb-6">
            <svg class="tw:w-5 tw:h-5 tw:text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 14.25l6-6m4.5-3.493V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185zM9.75 9h.008v.008H9.75V9zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm4.125 4.5h.008v.008h-.008V13.5zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"/>
            </svg>
            <h3 class="tw:text-lg tw:font-bold tw:text-slate-800">¿Desea aplicar un descuento?</h3>
        </div>

        <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-6">
            <!-- Descuento en % -->
            <BaseMultiselect
                :value="porcentajeVal"
                :options="descuentoOptions"
                label="Descuento en %"
                name="descuento_porcentaje"
                data-cy="descuento-input"
                value-key="value"
                label-key="label"
                :multiple="false"
                @input="onPorcentajeChange"
            />
            <!-- Descuento en € -->
            <BaseInputText
                v-model.number="integroVal"
                label="Descuento en €"
                name="descuento_euros"
                type="number"
                @input="onIntegroChange"
            />
        </div>
    </ValidationObserver>
</template>

<script setup>
    import { ref, computed, inject } from 'vue';
    import filters from '@/filters';
    import BaseInputText from '@/modules/admin/ui/BaseInputText.vue';
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue';

    const formData = inject('formData');

    const props = defineProps({
        importeTotal: { type: Number, default: 0 },
        descuentoOptions: { type: Array, default: () => [] },
    });

    // ── Estado local ──
    const observer = ref(null);
    const porcentajeVal = ref(formData?.descuento_aplicado || 0);
    const integroVal = ref(formData?.descuento_integro || null);

    const formatPrecio = filters.formatear_precio;

    // ── Cross-reset: al elegir porcentaje se resetea integro y viceversa ──
    function onPorcentajeChange(val) {
        porcentajeVal.value = val;
        if (val > 0) {
            integroVal.value = null;
        }
    }

    function onIntegroChange() {
        if (integroVal.value && integroVal.value > 0) {
            porcentajeVal.value = 0;
        }
    }

    // ── Validate ──
    async function validate() {
        return true;
    }

    // ── Datos para el padre ──
    function getData() {
        return {
            descuento_aplicado: porcentajeVal.value || 0,
            descuento_integro: integroVal.value || 0,
        };
    }

    defineExpose({
        get observer() { return observer.value; },
        validate,
        getData,
        // ── Setters expuestos para bypass desde tests E2E ──
        //   Vue 2.7 <script setup> NO expone refs automáticamente como
        //   propiedades en __vue__, por eso hace falta exponerlos
        //   explícitamente vía defineExpose.
        setPorcentaje(val) {
            porcentajeVal.value = val;
            if (val > 0) integroVal.value = null;
        },
        setIntegro(val) {
            integroVal.value = val;
            if (val && val > 0) porcentajeVal.value = 0;
        },
    });
</script>
